require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.tk = a());
}(this, function () {
  "use strict";

  return [{
    locale: "tk",
    pluralRuleFunction: function pluralRuleFunction(e, a) {
      var t = String(e).split("."),
          n = Number(t[0]) == e && t[0].slice(-1);
      return a ? 6 == n || 9 == n || 10 == e ? "few" : "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ýyl",
        relative: {
          0: "şu ýyl",
          1: "indiki ýyl",
          "-1": "geçen ýyl"
        },
        relativeTime: {
          future: {
            one: "{0} ýyldan",
            other: "{0} ýyldan"
          },
          past: {
            one: "{0} ýyl öň",
            other: "{0} ýyl öň"
          }
        }
      },
      "year-short": {
        displayName: "ý.",
        relative: {
          0: "şu ýyl",
          1: "indiki ýyl",
          "-1": "geçen ýyl"
        },
        relativeTime: {
          future: {
            one: "{0} ý-dan",
            other: "{0} ý-dan"
          },
          past: {
            one: "{0} ý. öň",
            other: "{0} ý. öň"
          }
        }
      },
      month: {
        displayName: "aý",
        relative: {
          0: "şu aý",
          1: "indiki aý",
          "-1": "geçen aý"
        },
        relativeTime: {
          future: {
            one: "{0} aýdan",
            other: "{0} aýdan"
          },
          past: {
            one: "{0} aý öň",
            other: "{0} aý öň"
          }
        }
      },
      "month-short": {
        displayName: "aý",
        relative: {
          0: "şu aý",
          1: "indiki aý",
          "-1": "geçen aý"
        },
        relativeTime: {
          future: {
            one: "{0} aýdan",
            other: "{0} aýdan"
          },
          past: {
            one: "{0} aý öň",
            other: "{0} aý öň"
          }
        }
      },
      day: {
        displayName: "gün",
        relative: {
          0: "şu gün",
          1: "ertir",
          "-1": "düýn"
        },
        relativeTime: {
          future: {
            one: "{0} günden",
            other: "{0} günden"
          },
          past: {
            one: "{0} gün öň",
            other: "{0} gün öň"
          }
        }
      },
      "day-short": {
        displayName: "gün",
        relative: {
          0: "şu gün",
          1: "ertir",
          "-1": "düýn"
        },
        relativeTime: {
          future: {
            one: "{0} g-den",
            other: "{0} g-den"
          },
          past: {
            one: "{0} g. öň",
            other: "{0} g. öň"
          }
        }
      },
      hour: {
        displayName: "sagat",
        relative: {
          0: "şu sagat"
        },
        relativeTime: {
          future: {
            one: "{0} sagatdan",
            other: "{0} sagatdan"
          },
          past: {
            one: "{0} sagat öň",
            other: "{0} sagat öň"
          }
        }
      },
      "hour-short": {
        displayName: "sag.",
        relative: {
          0: "şu sagat"
        },
        relativeTime: {
          future: {
            one: "{0} sag-dan",
            other: "{0} sag-dan"
          },
          past: {
            one: "{0} sag. öň",
            other: "{0} sag. öň"
          }
        }
      },
      minute: {
        displayName: "minut",
        relative: {
          0: "şu minut"
        },
        relativeTime: {
          future: {
            one: "{0} minutdan",
            other: "{0} minutdan"
          },
          past: {
            one: "{0} minut öň",
            other: "{0} minut öň"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "şu minut"
        },
        relativeTime: {
          future: {
            one: "{0} min-dan",
            other: "{0} min-dan"
          },
          past: {
            one: "{0} min. öň",
            other: "{0} min. öň"
          }
        }
      },
      second: {
        displayName: "sekunt",
        relative: {
          0: "häzir"
        },
        relativeTime: {
          future: {
            one: "{0} sekuntdan",
            other: "{0} sekuntdan"
          },
          past: {
            one: "{0} sekunt öň",
            other: "{0} sekunt öň"
          }
        }
      },
      "second-short": {
        displayName: "sek.",
        relative: {
          0: "häzir"
        },
        relativeTime: {
          future: {
            one: "{0} sek-dan",
            other: "{0} sek-dan"
          },
          past: {
            one: "{0} sek. öň",
            other: "{0} sek. öň"
          }
        }
      }
    }
  }];
});